import {useEffect} from 'react';
import DateLib from '../../../../../../lib/date';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {toast} from 'react-toastify';
import tippy from 'tippy.js';
import {cancelCashout} from '../../../../../../reducers/wallet/actions/chime_cashout';
import {useDispatch} from 'react-redux';

export default ({
    amounts,
    tag,
    paymentId,
    wager_burned,
    status,
    timestamp,  
    active,
    button,
    onClick
}) => {
    const dispatch = useDispatch();

    return (
        <div className={`payment ${active ? 'active' : ''} ${status === 0 ? 'pending' : ''}`}>
            <div className="top" onClick={onClick}>
                <div className="left">
                    <div className="icon cashapp chime">
                        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.26421 16C10.9565 16 12.8645 14.9825 14 14.1287V10.4211C12.3261 11.7427 10.3595 12.5029 8.61538 12.5029C5.82943 12.5029 3.87458 10.5848 3.87458 7.82456C3.87458 5.20468 5.65385 3.38012 8.19398 3.38012C9.02508 3.38012 9.73913 3.59064 10.5 3.80117C11.2843 4.02339 12.1037 4.26901 13.0753 4.26901C13.3796 4.26901 13.6839 4.24561 13.9883 4.19883V0.666667C13.7308 0.690059 13.4849 0.713451 13.2274 0.713451C12.3495 0.713451 11.5535 0.549708 10.7224 0.374269C9.84448 0.187135 8.94314 0 7.87793 0C5.7592 0 3.79264 0.748539 2.35284 2.12866C0.819398 3.59064 0 5.62573 0 8C0 12.7135 3.39465 16 8.26421 16Z" fill="white"></path></svg>
                    </div>
                    <div className="details">
                        <div className="name">
                            Chime
                        </div>
                        {DateLib.parse(timestamp)}
                    </div>
                </div>
                <div className="right">
                    <div className="info">
                        <div className={`amount ${status === 1 ? 'red' : 'pending'}`}>{status === 2 ? `- $${amounts.amount}` : `- $${amounts.amount}`}</div>

                        {status === 0 && (
                            <div className="status pending">
                                <div className="dot"></div>
                                Pending
                            </div>
                        )}

                        {status === 1 && (
                            <div className="status confirmed">
                                <div className="dot"></div>
                                Confirmed
                            </div>
                        )}

                        {status === 2 && (
                            <div className="status canceled">
                                <div className="dot"></div>
                                Canceled
                            </div>
                        )}
                    </div>

                    <div className="arrow">
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.9668 3.22003L10.3135 7.5667C10.8268 8.08003 10.8268 8.92003 10.3135 9.43336L5.9668 13.78" stroke="#4F546A" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
            </div>
            {active && (
                <div className="bottom">
                    <hr />
                    <div className="order-details">
                        <div className="detail">
                            <div className="label">Payment ID</div>
                            <CopyToClipboard text={`Chime cashout request #${paymentId} for $${amounts.amount} to ${tag}`} onCopy={e => {
                                toast.dismiss();
                                toast.info(`Transaction information has been copied to the clipboard`)
                            }}>
                                <div className="value">
                                    #{paymentId}

                                    <div className="icon">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M13.3327 10.7501V14.2501C13.3327 17.1668 12.166 18.3335 9.24935 18.3335H5.74935C2.83268 18.3335 1.66602 17.1668 1.66602 14.2501V10.7501C1.66602 7.83348 2.83268 6.66681 5.74935 6.66681H9.24935C12.166 6.66681 13.3327 7.83348 13.3327 10.7501Z" stroke="none"/>
                                            <path d="M14.249 1.66681H10.749C8.16562 1.66681 6.99895 2.58348 6.74895 4.75014C6.66562 5.25014 7.08229 5.58348 7.58229 5.58348H9.33229C12.8323 5.58348 14.4156 7.16681 14.4156 10.6668V12.5001C14.4156 13.0001 14.8323 13.3335 15.249 13.3335C17.4156 13.0835 18.3323 11.9168 18.3323 9.33348V5.75014C18.3323 2.83348 17.1656 1.66681 14.249 1.66681Z" stroke="none" />
                                        </svg>
                                    </div>
                                </div>
                            </CopyToClipboard>
                        </div>
                        <div className="detail">
                            <div className="label">Recipient</div>
                            <div className="value">{tag}</div>
                        </div>
                        <div className="detail">
                            <div className="label">Cashout amount</div>
                            <div className="value">${amounts.amount}</div>
                        </div>

                        {amounts.comission > 0 && (
                            <div className="detail">
                                <div className="label">Comission</div>
                                <div className="value">${amounts.comission}</div>
                            </div>
                        )}

                        {wager_burned > 0 && (
                            <div className="detail">
                                <div className="label">Wager burned</div>
                                <div className="value">${wager_burned}</div>
                            </div>
                        )}
                    </div>

                    {status === 0 && (
                        <div className="button" style={{
                            opacity: button ? 0.7 : 1,
                            cursor: button ? 'no-drop' : 'pointer'
                        }} onClick={e => {
                            if(button)
                                return;

                            dispatch(cancelCashout(paymentId));
                        }}>{!button ? `Cancel cashout` : `Please wait...`}</div>
                    )}
                </div>
            )}
        </div>
    )
}